import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const defaultState = {
  open: {
    confirm: false,
    alert: false,
    data: false,
  },
  header: null,
  message: '',
  component: null,
  callback: null,
  closeCallback: null,
  btnName: {
    confirm: '',
    close: '',
  },
};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations,
};
